import { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';

import AdminToolIcon from '@/assets/icons/admintool-icon.svg?react';
import RightMenu from '@/assets/icons/right-menu.svg?react';
import Header from '@/components/Header';
import NavigationBar from '@/components/NavigationBar';
import NavigationMenu from '@/components/NavigationMenu';
import { adminToolTabs } from '@/constants/adminTool';
import DrawerContext from '@/context/DrawerContext/DrawerContext';
import { useNavigationBar } from '@/context/NavigationBarContext';
import useIsSignedIn from '@/hooks/useIsSignedIn';
import styles from '@/layouts/styles.module.css';

function AdminToolLayout() {
  const userIsSignedIn = useIsSignedIn();
  const drawerCtx = useContext(DrawerContext);
  const { setTabsSegment } = useNavigationBar();

  const drawerContentMenu = NavigationMenu();

  useEffect(() => {
    setTabsSegment(adminToolTabs as []);
    return () => {
      setTabsSegment([]);
    };
  }, []);

  if (!userIsSignedIn) return <Navigate replace to="/login" />;

  return (
    <>
      <Header
        showLineSelector={false}
        links={[
          {
            URL: '/admin-tool/',
            icon: <AdminToolIcon />,
            component: <p>Admin Tool</p>
          }
        ]}
        icons={[
          <button
            key="menuIcon"
            onClick={() => {
              drawerCtx.updateDrawerContent(drawerContentMenu);
              drawerCtx.openDrawer();
            }}
          >
            <RightMenu className={styles.icon} />
          </button>
        ]}
      />
      <NavigationBar />
      <div className={styles.contentWrapper}>
        <Outlet />
      </div>
    </>
  );
}

export default AdminToolLayout;
